import { Box, styled } from "@mui/material";
import { DataGrid, Typography } from "@pmag/ui-components";

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    "& .MuiDataGrid-main": {
        boxShadow: "unset",
    },
    "& .MuiDataGrid-row:hover, & .MuiDataGrid-row.Mui-highlight": {
        backgroundColor: theme.palette.blue._10,
        "& + .MuiBox-root": {
            backgroundColor: theme.palette.blue._10,
        },
    },
}));

export const ArticleInfoBox = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
}));

export const ArticleImage = styled("img")(({ theme }) => ({
    width: "48px",
    height: "48px",
    objectFit: "contain",
    marginRight: theme.spacing(2),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(2),
}));
